export const additionalSounds = [
    {
        src: "sounds/storeBtn/pickup.mp3",
        id: "click",
    },
];
